import styled, {css} from 'styled-components'

export const StyledExplanationRoot = styled.div`
    ${({theme: {spacing}}) => css`
        max-width: 460px;
        margin: ${spacing}px auto;
        text-align: center;
    `}
`
